import { render, staticRenderFns } from "./AccessWalletCoolWallet.vue?vue&type=template&id=3f2650ec&scoped=true"
import script from "./AccessWalletCoolWallet.vue?vue&type=script&lang=js"
export * from "./AccessWalletCoolWallet.vue?vue&type=script&lang=js"
import style0 from "./AccessWalletCoolWallet.vue?vue&type=style&index=0&id=3f2650ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2650ec",
  null
  
)

export default component.exports